'use client'

import { NavOptions } from '@quark/header'
import { Translate } from '@quark/icons'
import { LOCALE_CONFIG } from '@configs/localeConfig'
import { LOCALE_SELECTOR_SOURCE_COOKIE, LOCALE_TOOLTIP_TARGET_ID } from '@constants/localisationConstants'
import { Locale } from '@enums/strapiTypesAndOperators'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'

const getLanguageChangeProps = (lang: Locale, selectedLanguage: Locale) => {
  let urlWithParam = ''
  let href = ''
  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/')
    if (selectedLanguage === Locale.English) {
      if (lang !== Locale.English) pathSegments.splice(1, 0, lang)
    } else if (lang === Locale.English) pathSegments.splice(1, 1)
    else pathSegments[1] = lang

    href = pathSegments.join('/')
    urlWithParam = getUrlWithQueryParams(href)
  }

  return {
    href,
    rel: 'alternate',
    onClick: () => {
      if (lang === selectedLanguage) return
      document.cookie = `${LOCALE_SELECTOR_SOURCE_COOKIE}=${lang}; path=/`
      window.location.href = urlWithParam
    },
  }
}

export function getLanguagePickerOptions(selectedLanguage: Locale, availableLanguages: Locale[]): NavOptions {
  const options = availableLanguages.map(lang => ({
    name: LOCALE_CONFIG[lang].name,
    icon: LOCALE_CONFIG[lang].icon,
    props: getLanguageChangeProps(lang, selectedLanguage),
    selected: selectedLanguage === lang,
  }))
  return {
    name: <Translate />,
    type: 'ghost',
    dropDownType: 'contentWidth',
    isExpandable: true,
    props: { id: LOCALE_TOOLTIP_TARGET_ID },
    options,
  }
}
